"use strict";
// lazyload config
Object.defineProperty(exports, "__esModule", { value: true });
angular.module('callX')
    /**
   * jQuery plugin config use ui-jq directive , config the js and css files that required
   * key: function name of the jQuery plugin
   * value: array of the css js file located
   */
    .constant('JQ_CONFIG', {
    plot: ['libs/jquery/flot/jquery.flot.js',
        'libs/jquery/flot/jquery.flot.resize.js',
        'libs/jquery/flot/jquery.flot.categories.min.js',
        'libs/jquery/flot.tooltip/js/jquery.flot.tooltip.min.js'],
    moment: ['libs/jquery/moment/moment.js'],
    screenfull: ['libs/jquery/screenfull/dist/screenfull.min.js'],
    wysiwyg: ['libs/jquery/bootstrap-wysiwyg/bootstrap-wysiwyg.js',
        'libs/jquery/bootstrap-wysiwyg/external/jquery.hotkeys.js'],
    vectorMap: ['libs/jquery/bower-jvectormap/jquery-jvectormap-1.2.2.min.js',
        'libs/jquery/bower-jvectormap/jquery-jvectormap-world-mill-en.js',
        'libs/jquery/bower-jvectormap/jquery-jvectormap-us-aea-en.js',
        'libs/jquery/bower-jvectormap/jquery-jvectormap.css'],
    fullcalendar: ['libs/jquery/moment/moment.js',
        'libs/jquery/fullcalendar/dist/fullcalendar.min.js',
        'libs/jquery/fullcalendar/dist/fullcalendar.css',
        'libs/jquery/fullcalendar/dist/fullcalendar.theme.css'],
    daterangepicker: ['libs/jquery/bootstrap-daterangepicker/daterangepicker.js',
        'libs/jquery/bootstrap-daterangepicker/daterangepicker-bs3.css']
})
    .constant('MODULE_CONFIG', [
    {}
])
    // oclazyload config
    .config(['$ocLazyLoadProvider', 'MODULE_CONFIG', function ($ocLazyLoadProvider, MODULE_CONFIG) {
        // We configure ocLazyLoad to use the lib script.js as the async loader
        $ocLazyLoadProvider.config({
            debug: false,
            events: true,
            modules: MODULE_CONFIG
        });
    }]);
